import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function expertiseAreas() {
  document.addEventListener('DOMContentLoaded', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    gsap.utils.toArray('.expertise-areas .card').forEach((card) => {
      if (reduce) {
        gsap.set(card, { autoAlpha: 1 });
        return;
      }

      gsap.from(card, {
        autoAlpha: 0,
        y: 30,
        duration: 0.6,
        ease: 'power2.out',
        clearProps: 'transform,opacity',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        }
      });
    });
  });
}